'use strict';

const FALLBACK_TIME_ZONE = "Asia/Seoul";
const UNKNOWN_TIME_ZONES = [
  /**
   * @description Windows 타임존이 "날짜 변경선 서쪽" 어쩌구로 되어 있으면
  크롬에서 Etc/Unknown 으로 나온다
   * https://flex-cv82520.slack.com/archives/CS05YNN9H/p1675666385986799?thread_ts=1675666206.822249&cid=CS05YNN9H
   */
  "Etc/Unknown",
  /**
   * @description 230817 macOS 최초 세팅시 타임존을 제대로 가져오지 못하는 이슈
   * https://flex-cv82520.slack.com/archives/C0124PPN82F/p1692264010830649?thread_ts=1692258305.623439&cid=C0124PPN82F
   */
  void 0,
  /**
   * @description 240306 macOS chrome version 122에서의 원인 모를 이슈 파악을 위해 추가
   * https://flex-cv82520.slack.com/archives/C03780R4NHX/p1709688338352649
   */
  null,
  ""
];
const getSystemTimeZone = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (UNKNOWN_TIME_ZONES.includes(timeZone)) {
    const globalKey = "__flex_isInvalidTimeZoneIdAlertAlreadyShown";
    if (typeof window !== "undefined" && window[globalKey] !== true) {
      const message = '\uD45C\uC900 \uC2DC\uAC04\uB300\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n\uC0AC\uC6A9\uD558\uC2DC\uB294 PC\uC758 "\uB0A0\uC9DC \uBC0F \uC2DC\uAC04" \uC124\uC815\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.';
      window.alert(message);
      window[globalKey] = true;
    }
    return FALLBACK_TIME_ZONE;
  }
  return timeZone;
};

module.exports = getSystemTimeZone;
//# sourceMappingURL=getSystemTimeZone.cjs.map
